import React, { useCallback, useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import { useObservable } from 'react-use-observable';


import RegistryBlockModal from 'v2/components/RegistryBlockModal';
import ModalFiscal from 'v2/components/Shared/ModalFiscal';
import { useGetBetaFeatures } from 'v2/hooks/useGetBetaFeatures';
import useGetPermissions from 'v2/hooks/useGetPermissions';
import { useRegistryCheck } from 'v2/hooks/useRegistryCheck';
import eduzzAccountsService from 'v2/services/eduzzAccount';
import { profileFactory } from 'v2/services/profile';

import { Topbar } from '@eduzz/ui-layout';
import { Icon } from '@eduzz/ui-antd-theme';

const NoPartner = () => {
  const [modalFiscal, setModalFiscal] = useState(false);
  const openModalFiscal = useCallback(() => setModalFiscal(true), []);
  const closeModalFiscal = useCallback(() => setModalFiscal(false), []);

  useEffect(() => profileFactory.load(), []);
  const [profile] = useObservable(() => profileFactory.get(), []);
  const [user] = useObservable(() => eduzzAccountsService.getUser(), []);
  const permissions = useGetPermissions();
  const { data: betaFeatures } = useGetBetaFeatures();
  const { data: registryCheck } = useRegistryCheck();

  const [showRegistryBlockModal, setShowRegistryBlockModal] = useState(false);

  const handleClick = useCallback(() => {
    if (user.cannot_become_partner) {
      toast.error('Você já possui uma conta parceira ou ligada a um produto na Eduzz!');
      return;
    }

    const usersToDisableRegistryBlock = [18396301];

    if (betaFeatures?.includes('disable_registry_block') || usersToDisableRegistryBlock.includes(user.id)) {
      openModalFiscal();
      return;
    }

    setShowRegistryBlockModal(true);
  }, [user?.cannot_become_partner, user?.id, betaFeatures, openModalFiscal]);

  const handleCancelRegistryBlockModal = useCallback(() => {
    setShowRegistryBlockModal(false);
    window.location.href = '/';
  }, []);

  const onCompleteModalFiscal = useCallback(() => {
    closeModalFiscal();
    window.location.href = '/';
  }, [closeModalFiscal]);

  return (
    <>
      <Topbar.Action icon={<Icon.Zap  />} label='Quero Vender' onClick={handleClick} />
      <RegistryBlockModal
        opened={showRegistryBlockModal}
        isOwner={permissions?.owned}
        cancelable={registryCheck?.skip}
        onCancel={handleCancelRegistryBlockModal}
        hideCancelButton={true}
        redirectTo={encodeURIComponent(`${window.location.origin}/producer/dashboard?from=registry`)}
      />
      <ModalFiscal
        opened={modalFiscal}
        onClose={closeModalFiscal}
        onComplete={onCompleteModalFiscal}
        profile={profile}
      />
    </>
  );
};

export default NoPartner;
